<template>
  <div class="mb-3">
    <label
      class="block text-sm font-medium text-gray-700 dark:text-gray-400"
      :for="id"
    >
      <slot name="label">{{ label }}</slot>
    </label>
    <div class="mt-1">
      <slot :id="id" />
    </div>
  </div>
</template>

<script>
export default {
  name: "UiInputGroup",
  props: ['label'],
  data() {
    return {
      id: `ui-input-group-${Math.floor(Date.now() * Math.random())}`
    }
  }
}
</script>

<style scoped>

</style>
